<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('common.dealers') }}
      </h1>
      <div class="ml-auto">
        <v-btn
          outlined
          large
          @click="toggleFilter"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <dealers-filter
      v-model="isFilterShown"
      :filter="filter"
      @applyFilter="applyFilter"
    />
    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
    >
      <template v-slot:item.actions="{ item }">
        <v-hover v-slot="{hover}">
          <v-icon
            :class="hover ? '' : 'text--disabled'"
            color="primary"
            size="20"
            @click="showDealer(item.asdb)"
          >
            mdi-open-in-new
          </v-icon>
        </v-hover>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DealersFilter from '@/components/dealers/DealersFilter';
import { mapState } from 'vuex';

export default {
  name: 'DealerList',

  components: {
    DealersFilter,
  },

  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      options: {
        page: 1,
      },

      headers: [
        { text: this.$t('common.name'), value: 'name' },
        //{ text: 'ASDB', value: 'asdb', width: '150px' },
        { text: 'Код СТО', value: 'asdb', width: '150px' },
        { text: this.$t('common.credit_limit'), value: 'creditLimit', width: '150px' },
        {
          text: this.$t('common.actions'), value: 'actions', sortable: false, width: 150, align: 'center',
        },
      ],

      filter: {
        name: '',
        asdb: '',
        creditLimit: null,
      },
      isFilterShown: false,
    };
  },

  computed: {
    ...mapState(['workMode']),
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  created() {
    this.setWorkModeLayout();
  },

  methods: {
    setWorkModeLayout() {
      if (this.workMode.isModeSollers) {
        this.headers.splice(this.headers.findIndex((item) => item.value === 'creditLimit') + 1, 0,
          { text: this.$t('common.advance_balance_regular'), value: 'advanceBalance.regular', width: '150px' },
          { text: this.$t('common.advance_balance_cross'), value: 'advanceBalance.crossDocking', width: '150px' });
      }
    },

    showDealer(asdb) {
      this.$router.push(`dealer/${asdb}`);
    },

    async getItems() {
      this.loading = true;

      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const filter = this.mapFilter();

      const params = {
        query: filter,
        pageSize: itemsPerPage,
        page,
      };

      if (sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      try {
        const { data } = await this.$http.get('dealers', { params });
        this.items = data.rows.map((item) => ({ advanceBalance: {}, ...item }));
        this.total = data.total;
      } finally {
        this.loading = false;
      }
    },

    toggleFilter() {
      this.isFilterShown = !this.isFilterShown;
    },

    applyFilter(filter) {
      this.filter = { ...filter };
      this.options.page = 1;
      this.getItems();
    },

    mapFilter() {
      const filter = {};
      if (this.filter.name) {
        filter.name = {
          $regex: `.*${this.filter.name}.*`,
          $options: 'i',
        };
      }
      if (this.filter.asdb) {
        filter.asdb = {
          $regex: `.*${this.filter.asdb}.*`,
          $options: 'i',
        };
      }
      if (typeof this.filter.creditLimit === 'number') {
        filter.creditLimit = this.filter.creditLimit;
      }
      return filter;
    },
  },
};
</script>
